export default __webpack_public_path__ + "static/the_energy_of_joy_3-6ead4c3b63aff527461963ae84229ad2.png";